"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useModals = void 0;
const react_1 = __importDefault(require("react"));
const contexts_1 = require("../contexts");
/**
 * Expose usage of modals inside Exchange.
 *
 * @example
 *
 * ```tsx
 * import { useModals } from '@mulesoft/exchange-react-hooks';
 *
 * const MyModal = ({ myProp }) => {
 *   const { closeModal } = useModals();
 *
 *   return (
 *     <div>
 *       <p>Modal content {myProp}</p>
 *       <button onClick={() => closeModal()}>Close</button>
 *     </div>
 *   );
 * };
 *
 * const MyComponent = () => {
 *   const { openModal } = useModals();
 *
 *   return (
 *     <button onClick={() => openModal(MyModal, { myProp: 'foo' })}>
 *       Open modal
 *     </button>
 *   );
 * };
 * ```
 *
 * See [this component](https://github.com/mulesoft/exchange-ui-components/tree/master/src/components/ConfirmModal) for an example of a modal in Exchange.
 *
 * @returns An object to interact with modals
 */
function useModals() {
    return react_1.default.useContext(contexts_1.ModalContext);
}
exports.useModals = useModals;
